export const translations = {
  registrosSelec: {
    pt: 'registros(s) selecionados.',
    en: 'record(s) selected.',
    de: 'Datensätze ausgewählt.',
    es: 'registro(s) seleccionado(s).',
  },
  registrosPag: {
    pt: 'Registros por página',
    en: 'Records per page',
    de: 'Einträge pro Seite',
    es: 'Registros por página',
  },
  pagina: {
    pt: 'Página',
    en: 'Page',
    de: 'Seite',
    es: 'Página',
  },
  primeira: {
    pt: "Ir para a primeira página",
    en: ' Go to first page',
    de: 'Gehen Sie zur ersten Seite',
    es: 'Ir a la primera página',
  },
  ultima: {
    pt: "Ir para a última página",
    en: '',
    de: 'beschreibung',
    es: 'descripción',
  },
  anterior: {
    pt: "Anterior",
    en: 'description',
    de: 'beschreibung',
    es: 'descripción',
  },
  proxima: {
    pt: "Próxima",
    en: 'description',
    de: 'beschreibung',
    es: 'descripción',
  },
  linhasSelecionadas: {
    pt: 'linha(s) selecionada(s).',
    en: 'selected line(s).',
    de: 'ausgewählte Zeile(n).',
    es: 'línea(s) seleccionada(s).',
  },
  de: {
    pt: 'de',
    en: 'of',
    de: 'von',
    es: 'de',
  },
  semResultados: {
    pt: 'Sem resultados.',
    en: 'No results',
    de: 'Keine Ergebnisse',
    es: 'No hay resultados',
  },
  filtrar: {
    pt: 'Filtrar',
    en: 'Filter',
    de: 'Filter',
    es: 'Filtrar',
  }
}